import { render, staticRenderFns } from "./temhead1.vue?vue&type=template&id=6871df55&scoped=true"
import script from "./temhead1.vue?vue&type=script&lang=js"
export * from "./temhead1.vue?vue&type=script&lang=js"
import style0 from "./temhead1.vue?vue&type=style&index=0&id=6871df55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6871df55",
  null
  
)

export default component.exports